import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import BookingSystemsTable from '../../containers/BookingSystemsTable'
import CreateBookingSystemModal from '../../containers/CreateBookingSystemModal'
import EditBookingSystemModal from '../../containers/EditBookingSystemModal'
import NewBookableTimeModal from '../../containers/NewBookableTimeModal'
import EditBookableTimeModal from '../../containers/EditBookableTimeModal'

import * as dataActions from '../../actions/Data'

class BookingSystems extends React.Component {
  componentDidMount() {
    const { data } = this.props

    this.fetch()
  }

  fetch() {
    const { user, data } = this.props

    if (!data.bookingSystemsFetched) {
      this.props.tryGetBookingSystem(user.token, data.community.id)
    }
  }

  render() {
    const { classes } = this.props

    return (
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <BookingSystemsTable />
        <CreateBookingSystemModal />
        <EditBookingSystemModal />
        <NewBookableTimeModal />
        <EditBookableTimeModal />
      </main>
    )
  }
}

const Styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto'
  }
})

BookingSystems.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data, user }) {
  return { data, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...dataActions }, dispatch)
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(BookingSystems)



// WEBPACK FOOTER //
// ./src/components/pages/BookingSystems/index.js